import { render, staticRenderFns } from "./ThemedIcon.vue?vue&type=template&id=f7ec2cec"
import script from "./ThemedIcon.vue?vue&type=script&lang=ts"
export * from "./ThemedIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports